module.exports = __webpack_public_path__ + "img/117.5.020744c7.png";